import Vue from 'vue'
import DownloadMediaBlock from '@/Redesign/Components/DownloadMedia/DownloadMediaBlock.vue'
import useDownloadMedia from '@/Redesign/Compositions/useDownloadMedia'

const addMediaBlockToPage = () => {
  const DownloadMediaBlockClass = Vue.extend(DownloadMediaBlock)
  const downloadMediaBlockIInstance = new DownloadMediaBlockClass()
  downloadMediaBlockIInstance.$mount()
  document.body.appendChild(downloadMediaBlockIInstance.$el)
}

export default () => {
  const links = document.querySelectorAll('.js-download-media')
  const {
    state,

    setInfo,
    setShowModal
  } = useDownloadMedia()

  if (!links.length) {
    return
  }

  links.forEach((link) => {
    /*
      There is two lftracker eventListeners that copies the event and dispatch them
      together with original one. In order to fix it, all listeners need to be removed.
    */
    const model = JSON.parse(link.getAttribute('data-model'))
    const linkCloneWithoutEventListeners = link.cloneNode(true)
    link.parentNode.replaceChild(linkCloneWithoutEventListeners, link)

    linkCloneWithoutEventListeners.addEventListener('click', (e) => {
      e.preventDefault()
      if (!state.created) {
        addMediaBlockToPage()
      }
      setInfo(model)
      setShowModal(true)
    }, false)
  })
}
